<template>
  <div class=page-view>
    <div class=rezervacija-form>
      <ejs-dropdownlist v-model='eventName' placeholder="Vrsta*" :dataSource='this.$store.state.eventNameList' floatLabelType="Always"></ejs-dropdownlist>
      <ejs-dropdownlist v-model='eventStatus' placeholder="Status*" :dataSource='this.$store.state.eventStatusList' floatLabelType="Always"></ejs-dropdownlist>
      <ejs-textbox v-model='clientName' floatLabelType="Auto" placeholder="Klijent*" width="100%"></ejs-textbox>
      <ejs-textbox v-model='clientTelefon' floatLabelType="Auto" placeholder="Telefon" width="100%"></ejs-textbox>
      <ejs-textbox v-model='clientEmail' floatLabelType="Auto" placeholder="Email" width="100%"></ejs-textbox>
      <ejs-textbox v-model='clientNote' floatLabelType="Auto" placeholder="Napomena" width="100%"></ejs-textbox>
      <ejs-datepicker v-model='pickupDate' placeholder="Datum preuzimanja*" floatLabelType="Always" :format="dateFormat"></ejs-datepicker>
      <ejs-timepicker v-model='pickupTime' placeholder="Vrijeme preuzimanja*" floatLabelType="Always" :format="timeFormat" :step="timeStep" :min="this.minTime" :max="this.maxTime"></ejs-timepicker>
      <ejs-textbox v-model='pickupPlace' floatLabelType="Auto" placeholder="Lokacija preuzimanja" width="100%"></ejs-textbox>
      <ejs-datepicker v-model='dropDate' placeholder="Datum povratka*" floatLabelType="Always" :format="dateFormat" :min="this.minimunReturnDate"></ejs-datepicker>
      <ejs-timepicker v-model='dropTime' placeholder="Vrijeme povratka*" floatLabelType="Always" :format="timeFormat" :step="timeStep" :min="this.minTime" :max="this.maxTime"></ejs-timepicker>
      <ejs-textbox v-model='dropPlace' floatLabelType="Auto" placeholder="Lokacija povratka" width="100%"></ejs-textbox>
      <p v-if="this.saveDisabled" style="text-align: center;">Popunite obavezna polja (*)</p>
      <ejs-button class=save-btn v-on:click.native='onSpremi' :disabled="this.saveDisabled">SPREMI</ejs-button>
    </div>
  </div>
</template>

<style lang="scss">
.rezervacija-form {
  width: 80%;
  margin: 0 auto 0 auto;
}
</style>

<script>
export default {
  name: 'event_info',
  data() {
    return {
      isEditMode: false,
      dateFormat : 'dd.MM.yyyy',
      timeFormat : 'HH:mm',
      timeStep : 15,
      minTime: new Date(2020, 3, 8, 5, 0),
      maxTime: new Date(2020, 3, 8, 21, 0),

      eventName: undefined,
      eventStatus: undefined,
      clientName: undefined,
      clientTelefon: undefined,
      clientEmail: undefined,
      clientNote: undefined,
      pickupDate: undefined,
      pickupTime: undefined,
      pickupPlace: undefined,
      dropDate: undefined,
      dropTime: undefined,
      dropPlace: undefined,
    }
  },
  mounted() {
    this.$store.state.currentView = 'rezervacija';
    this.$store.state.previousView = 'rezervacije';
    this.$store.state.hideCloseIcon = false;
    this.$store.state.hideReturnIcon = true;
    this.$store.state.hideSettingIcon = true;
    this.$store.state.hideFloatWidgetRight = true;
    this.$store.state.viewTitle = 'Rezervacija';
    if (this.$store.state.selectedEvent) {
      this.isEditMode = true;
      this.$store.state.viewTitle = 'Uredi rezervaciju';
      this.loadEditData();
    } else {
      this.$store.state.viewTitle = 'Nova rezervacija';
    }
  },
  computed: {
    saveDisabled() {
      if (this.eventName && this.eventStatus && this.clientName && this.pickupDate && this.pickupTime && this.dropDate && this.dropTime) return false;
      return true;
    },
    minimunReturnDate() {
      if (!(this.pickupDate)) return new Date();
      let d;

      if (typeof this.pickupDate === "object") d = this.formatDate(this.pickupDate).split('.');
      if (typeof this.pickupDate === "string") d = this.pickupDate.split('.');

      if (d.length !== 3) return new Date();
      return new Date(parseInt(d[2]), parseInt(d[1])-1, parseInt(d[0]));
    }
  },
  methods: {
    onSpremi() {
      let en, es;

      if (this.eventName === this.$store.state.eventNameList[0]) en = '0';
      if (this.eventName === this.$store.state.eventNameList[1]) en = '1';

      if (this.eventStatus === this.$store.state.eventStatusList[0]) es = '1';
      if (this.eventStatus === this.$store.state.eventStatusList[1]) es = '0';
      
      const payload = {
        carID: this.$store.state.selectedCar.ID,
        eventName: en,
        eventStatus: es,
        clientName: this.clientName,
        clientTelefon: this.clientTelefon,
        clientEmail: this.clientEmail,
        clientNote: this.clientNote,
        pickupDate: this.formatDate(this.pickupDate),
        pickupTime: this.formatTime(this.pickupTime),
        pickupPlace: this.pickupPlace,
        dropDate: this.formatDate(this.dropDate),
        dropTime: this.formatTime(this.dropTime),
        dropPlace: this.dropPlace
      };
      
      if (this.isEditMode === false) {
          this.$store.dispatch('insertEvent', payload).then(res => {
            this.$parent.showNotification(res);
            this.$router.push(this.$store.state.previousView);
          })
          .catch(err => this.$parent.showNotification(err));
      } else {
          payload.ID = this.$store.state.selectedEvent.ID;
          this.$store.dispatch('updateEvent', payload).then(res => {
            this.$parent.showNotification(res);
            this.$router.push(this.$store.state.previousView);
          })
          .catch(err => this.$parent.showNotification(err));
      }
    },
    getEventValue(key) {
      if (this.$store.state.selectedEvent) return this.$store.state.selectedEvent[key] || undefined;
      return undefined;
    },
    loadEditData() {
      this.eventName = this.getEventName();
      this.eventStatus = this.getEventStatus();
      this.clientName = this.getEventValue('clientName');
      this.clientTelefon = this.getEventValue('clientTelefon');
      this.clientEmail = this.getEventValue('clientEmail');
      this.clientNote = this.getEventValue('clientNote');
      this.pickupDate = this.getEventValue('pickupDate');
      this.pickupTime = this.getEventValue('pickupTime');
      this.pickupPlace = this.getEventValue('pickupPlace');
      this.dropDate = this.getEventValue('dropDate');
      this.dropTime = this.getEventValue('dropTime');
      this.dropPlace = this.getEventValue('dropPlace');
    },
    getEventName() {
      let event = this.$store.state.selectedEvent;
      if (event) 
      {
        if(event.eventName === '0') return this.$store.state.eventNameList[0];  //najam
        if(event.eventName === '1') return this.$store.state.eventNameList[1];  //rezervacija
      }
      return undefined;
    },
    getEventStatus() {
      let event = this.$store.state.selectedEvent;
      if (event) 
      {
        if(event.eventStatus === '1') return this.$store.state.eventStatusList[0];  //aktivno
        if(event.eventStatus === '0') return this.$store.state.eventStatusList[1];  //završeno
      }
      return this.$store.state.eventStatusList[0];  //aktivno
    },
    formatDate(d) {
      //d - date object
      let D = d.getDate();
      D = D < 10 ? '0' + D.toString() : D.toString();
      let M = d.getMonth() + 1;
      M = M < 10 ? '0' + M.toString() : M.toString();
      let Y = d.getFullYear();
      return ( D + "." + M + "." + Y);
    },
    formatTime(t) {
      //t - date object
      let H = t.getHours();
      H = H < 10 ? '0' + H.toString() : H.toString();
      let M = t.getMinutes();
      M = M < 10 ? '0' + M.toString() : M.toString();
      return (H + ":" + M);
    }
  }
}
</script>